<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12">
                <v-tabs
                    v-model="tab"
                    color="darkGreen"
                    @update:model-value="init()"
                    >
                    <v-tab value="0" :class="{'font-weight-black': tab == '0'}">For Review</v-tab>
                    <v-tab value="reviewed" :class="{'font-weight-black': tab == 'reviewed'}">Reviewed</v-tab>
                    <v-tab value="returned" :class="{'font-weight-black': tab == 'returned'}">Returned</v-tab>
                </v-tabs>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-select
                    v-model="selectedCompliance"
                    :items="complianceOptions"
                    label="Sort by Compliance"
                    variant="outlined"
                    density="comfortable"
                    dense
                    hide-details
                    solo
                    rounded="lg"
                    color="primary"
                ></v-select>
            </v-col>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="dt-container mt-2">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="filteredData"
                                :search="search"
                                :loading="loading"
                                :items-per-page="15"
                                :items-per-page-options="[15,30, 50, 100, -1]"
                                :custom-filter="customSearch"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.compliance="{ item }">
                                <div class="text-truncate" style="max-width: 200px;">
                                    {{ item.compliance.compliance_name }}
                                </div>
                            </template>
                            <template v-slot:item.submittedBy="{ item }">
                                <div>
                                    {{ item.file.submittedBy.fname }} {{ item.file.submittedBy.lname }}
                                </div>
                            </template>
                            <template v-slot:item.date_submitted="{ item }">
                                <div>
                                    {{ formatDate(item.date_submitted) }}
                                </div>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                    <v-btn @click="showReviewDialog(item)" size="small" variant="outlined" text="View" color="green-accent-4" elevation="2"></v-btn>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <ComplianceReviewDialog ref="ComplianceReviewDialog" @refresh="init()" />
    </v-container>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import ComplianceReviewDialog from '../Dialogs/ComplianceReviewDialog.vue';
export default defineComponent({
    components: {
        ComplianceReviewDialog,
    },
    data(){
        return {
            data: [],
            search: null,
            loading: false,
            headers: [
                { title: 'Submitted By', align: 'start', sortable: true, key: 'submittedBy' },
                { title: 'Course Load', align: 'start', sortable: true, key: 'facultyLoad.code' },
                { title: 'Compliance', align: 'start', sortable: true, key: 'compliance' },
                { title: 'Date Submitted', align: 'start', sortable: true, key: 'date_submitted' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            schoolYearData: [],
            schoolyear_id: null,
            selectedSchoolyear: null,
            complianceOptions: [],
            selectedCompliance: 'All',

            smAndDown: false,
            
            tab: '0'
        }
    },
    computed: {
        filteredData() {
            if (!this.selectedCompliance || this.selectedCompliance == 'All') return this.data;

            return this.data.filter(
                (item) => item.compliance?.compliance_name === this.selectedCompliance
            );
        }
    },
    methods: {
        init(){
            if(this.tab == '0'){
                this.loading = true
                const token = localStorage.getItem('aums-token')
                axios.get(process.env.VUE_APP_SERVER_URL + '/compliance-upload-details/findAllComplianceForReview/' + this.$store.state.semester_schoolyear.id + '/' + this.$store.state.user.programId,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data){
                        this.loading = false
                        this.data = res.data
                        this.complianceOptions = ['All', ...new Set(res.data.map(item => item.compliance?.compliance_name))].filter(Boolean);
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                });
            }
            else{
                this.loading = true
                const token = localStorage.getItem('aums-token')
                axios.get(process.env.VUE_APP_SERVER_URL + '/compliance-upload-details/findAllComplianceForReview/' + this.$store.state.semester_schoolyear.id + '/' + this.$store.state.user.programId + '/?status=' + this.tab,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data){
                        this.loading = false
                        this.data = res.data
                        this.complianceOptions = ['All', ...new Set(res.data.map(item => item.compliance?.compliance_name))].filter(Boolean);
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                });
            }
        },
        showReviewDialog(data){
            this.$refs.ComplianceReviewDialog.initView(data)
        },
        customSearch(value, search, item) {
            if (!search) return true;

            const fullName = `${item.fname ?? ''} ${item.mname ?? ''} ${item.lname ?? ''} ${item.suffix ?? ''}`.toLowerCase();
            const safeSearch = search?.toLowerCase() ?? '';

            return (
            fullName.includes(safeSearch) ||
            JSON.stringify(item).toLowerCase().includes(safeSearch)
            );
        },
    },
    mounted(){
        this.init()
    }
})
</script>

<style scoped>

</style>